import { render, staticRenderFns } from "./v-animated-number.vue?vue&type=template&id=3271d9a8&"
import script from "./v-animated-number.vue?vue&type=script&lang=js&"
export * from "./v-animated-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports